import { useEffect, useState } from 'react'
import { getSubmit } from '@ui-seeker/utils'

import { BACKEND_APIS, SERVICES_TYPE } from '@constants'


const asList = res => (Array.isArray(res) ? res : [])

/**
 * What a BI dashboard opens with (CU-869fmhmx8 D8, D11): the offices, rental lengths and currencies BI offers this
 * user (same lists as BI, `service_type=bi`) and the office (and currency) of the user's latest BI query. Any of them may fail on
 * its own: the dashboard then falls back to what it has.
 */
export default function useDashboardOptions() {
	const [state, setState] = useState({ loading: true, offices: [], lors: [], currencies: [], lastOffice: null, lastCurrency: null })

	useEffect(() => {
		let alive = true
		const filters = { service_type: SERVICES_TYPE.BI }
		Promise.allSettled([
			getSubmit(`${BACKEND_APIS.MASTER_DATA}/options/office`, filters),
			getSubmit(`${BACKEND_APIS.MASTER_DATA}/options/lor`, filters),
			getSubmit(`${BACKEND_APIS.MASTER_DATA}/options/currencies`, filters),
			getSubmit(`${BACKEND_APIS.DASHBOARD}/last-office`, null, { retries: 1 }),
		]).then(([offices, lors, currencies, last]) => {
			if (!alive) return
			const value = r => (r.status === 'fulfilled' ? r.value : null)
			setState({
				loading: false,
				offices: asList(value(offices)),
				lors: asList(value(lors)).map(x => ({ ...x, value: Number(x.value) })).filter(x => Number.isInteger(x.value) && x.value > 0),
				currencies: asList(value(currencies)),
				lastOffice: value(last)?.officeId ?? null,
				// the currency of the same query, for the questions of Advanced (BI) (CU-869fmk5ge T3)
				lastCurrency: value(last)?.currency ?? null,
			})
		})
		return () => { alive = false }
	}, [])

	return state
}
